<template>
    <div class="login">
        <div class="login__hero">
            <div class="login-card">
                <h1 class="login-card__title">{{ $t('views.login.title') }}</h1>

                <Former
                    :action="submit"
                    :buttonLabel="$t('views.login.sign_in')"
                    :errorMessage="err_msg"
                >
                    <input v-model="credentials.email" id="login-user" type="text" class="input-txt" :placeholder="`${ $t('email') }/${ $t('views.login.customer_number') }`" />
                    <input v-model="credentials.password" id="login-pw" type="password" class="input-txt" :placeholder="$t('views.login.password')" />
                </Former>

                <a class="login-card__forgot" :href="forgotPasswordLink">
                    {{ $t('views.login.forgot_password') }}
                </a>
            </div>
        </div>

        <div class="login__content">
            <h2 class="login__content__title">{{ $t('views.login.register_title') }}</h2>

            <ul class="register-list">
                <li class="register-list__item">
                    <a :href="registerLeasingLink" class="register-list__item__link register-list__item__link--tilted">
                        {{ $t('views.login.sublet') }}
                    </a>
                </li>
                <li class="register-list__item">
                    <a :href="registerCompanyLink" class="register-list__item__link register-list__item__link--sublet">
                        {{ $t('views.login.corporate') }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, reactive } from 'vue'
    import { useStore }         from 'vuex'
    import { useRouter }        from 'vue-router'
    import { currentLang }      from '@/helpers'
    import authStoreActions     from '@constans/store/auth/authStoreActions'
    import authStoreGetters     from '@constans/store/auth/authStoreGetters'
    import globalStoreMutations from '@constans/store/global/globalStoreMutations'
    import Former               from '@components/form/Former.vue'

    export default defineComponent({
        components: {
            Former
        },
        setup() {
            const store = useStore()
            const router = useRouter()
            const credentials = reactive({
                email: '',
                password: ''
            })

            const err_msg = computed(() => store.getters[`auth/${ authStoreGetters.GET_LOGIN_ERR_MSG }`])
            const forgotPasswordLink = computed(() => currentLang === 'en' ? '/en/forgot-password' : '/sv/glomt-losenord')
            const registerLeasingLink = computed(() => currentLang === 'en' ? '/en/register-your-home' : '/sv/hyr-ut-bostad')
            const registerCompanyLink = computed(() => currentLang === 'en' ? '/en/residential-services-for-companies' : '/sv/bostadsservice-for-foretag')

            const submit = () => {
                store.commit(`global/${ globalStoreMutations.UPDATE_LOADER }`, true)

                store.dispatch(`auth/${ authStoreActions.LOGIN }`, credentials).then(() => {
                    
                    setTimeout(() => {
                        store.commit(`global/${ globalStoreMutations.UPDATE_LOADER }`, false)
                        router.push({ name: 'dashboard' })
                    }, 1000)
                })
            }

            return {
                currentLang,
                credentials,
                err_msg,
                forgotPasswordLink,
                registerLeasingLink,
                registerCompanyLink,
                submit
            }
        }
    })
</script>
